import React, {useState, useEffect } from 'react';
import {Row, Col, Table} from 'antd';
import {getMethod} from '../services/methods';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import * as dayjs from 'dayjs'

const totalTaskColumns = [
    {
        title: 'Şehir',
        dataIndex: '_id',
        key: '_id'
    },
    {
        title: 'Ziyaret Sayısı',
        dataIndex: 'taskCount',
        key: 'taskCount'
    },
];

export default function CompletedReport(props) {
    const today = new Date();
    const [completedDataLoading, setCompletedDataLoading] = useState(false);
    const [completedData, setCompletedData] = useState([]);
    const [startDate, setStartDate] = useState(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7));
    const [endDate, setEndDate] = useState(new Date());


    async function fetchCompletedData() {
        setCompletedDataLoading(true)
        const completedData = await getMethod(`/dashboard/completed/${props.type}`, {
            startDate: dayjs(startDate).format('YYYY/MM/DD'),
            endDate: dayjs(endDate).format('YYYY/MM/DD'),
        });
        console.log("completedData", completedData)
        setCompletedDataLoading(false)
        setCompletedData(completedData)
    }

    useEffect(() => {
        fetchCompletedData();
    }, [startDate, endDate])

    return (
        <div>
            <Row className="dashboard-rows" style={{marginBottom: "16px"}} >
                <Col span={24}>
                    <div style={{ border: "solid", borderWidth: 0.5, padding: 20, borderColor: 'rgb(201,201,201)'}}>
                        <h1>Toplam Yapılan Ziyaret</h1>
                        <div style={{display: "flex", marginBottom: 10}}>
                            <div style={{marginRight: 5}}>Başlangıç Zamanı:</div>
                            <div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    selectsStart
                                    startDate={startDate}
                                    endDate={endDate}/>
                            </div>
                            <div style={{marginLeft: 20, marginRight: 5}}>Bitiş Zamanı:</div>
                            <div>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    selectsEnd
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: 30}}>
                            <Table
                                loading={completedDataLoading ? true : false}
                                rowKey={(data) => data._id}
                                columns={totalTaskColumns}
                                dataSource={completedData}
                                pagination={false}/>
                        </div>

                    </div>
                </Col>
            </Row>

        </div>
    )
}
